import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ServiceTransportModalForm from "../../Forms/ServiceForms/ServiceTransportModalForm/ServiceTransportModalForm";

const ServiceTransportModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:service.serviceTransport"), error: false }
  ]);

  const formName = "ServiceTransportModalForm";
  const { handleHide, show } = props;


  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"700px"}
      height={"600px"}
      onClose={handleHide}
      header={props.header}

      steps={steps}
    >
      <ServiceTransportModalForm
        steps={steps}
        step={step}
        setStep={setStep}
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "ServiceTransportModal" })(ServiceTransportModal);
